import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  DsEmptyStateModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
  DsToastService,
} from '@bmw-ds/components';
import { finalize, Observable, take } from 'rxjs';
import { SharedService } from 'src/app/services/shared-service';

@Component({
  selector: 'app-error',
  imports: [DsEmptyStateModule],
  templateUrl: './error.html',
  styleUrl: './error.scss',
})
export class Error implements OnInit {
  constructor() {}

  sharedService = inject(SharedService);
  toastService = inject(DsToastService);
  destroyRef = inject(DestroyRef);
  loadingAreaService = inject(DsLoadingAreaService);

  loadingAreaConfig: DsLoadingAreaConfiguration = { id: 'errorLoader' };

  errorMessage$: Observable<string> = this.sharedService.getErrorMessage();
  message: string = '';

  async ngOnInit() {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.errorMessage$
      .pipe(
        take(1),
        finalize(() => {
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: (response) => {
          this.sharedService.logger('Error Component error received', response);
          this.message = response;
        },
        error: (error) => {
          this.message = 'Something went wrong. Please try again later.';
        },
        complete: () => {},
      });
  }

  openRightNowPortalInNewTab() {
    const url =
      'https://portal.rightnow.azure.cloud.bmw/new/html/qer-app-portal/index.html';
    window.open(url, '_blank')?.focus();
  }
}
